
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const companies = state => state.companies;
const supplier = state => state.companies.filter(c => c.companycategory_id == 2)
const getsingle = state => param =>state.companies.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  companies,
  getsingle,
  supplier
};